import { Link } from 'react-router-dom';
import { RiMenuFill } from "react-icons/ri";
import { FaHome } from "react-icons/fa";

import ProductsMenu from './ProductsMenu';

function Navbar({ isOpen, setIsOpen }) {
    return (
        <>
        <nav className='relative w-full opacity-0 animate-slide-in-down flex flex-col sm:flex-row lg:text-lg 2xl:text-xl sm:flex-wrap sticky top-0 z-50 h-[20vh] sm:h-[3vh] lg:h-[8vh] 2xl:h-[6vh] min-h-[6vh] bg-brun-main text-beige shadow'>
            <ul className="flex flex-row w-full flex-1 h-full items-center justify-evenly">
                <li className="relative group p-2">
                    <Link to='/' className='hover:text-brun-dark'><FaHome/></Link>
                </li>
                <li className="relative group p-2">
                    <span className="flex flex-row items-center gap-3" onMouseEnter={() => setIsOpen(true)} onClick={() => setIsOpen(!isOpen)}>
                        <RiMenuFill/>Nos produits
                    </span>
                </li>
            </ul>
            <ul className="flex flex-row w-full flex-1 h-full border-double max-sm:border-y-4 max-sm:border-brun-contrast/50 sm:border-x-4 sm:border-brun-contrast/50 items-center justify-evenly">
                <li className="relative group p-2">
                    <Link to='/nous-connaitre/' className='hover:text-brun-dark'>Nous connaître</Link>
                </li>
                <li className="relative group p-2">
                    <Link to='/inspirations/' className='hover:text-brun-dark mr-16 sm:mr-0'>Inspirations</Link>
                </li>
            </ul>
            <ul className="flex flex-row w-full flex-1 h-full items-center justify-center">
                <li className="relative group p-2">
                    <Link to='/devis/' className="px-2 lg:px-4 xl:px-8 py-1 sm:py-2 xl:py-3 2xl:py-4 rounded-full bg-brun-contrast text-brun-dark hover:bg-brun-dark hover:text-beige transition duration:300">Obtenir un devis gratuit</Link>
                </li>
            </ul>
            <div className="absolute top-full left-0 w-full sm:h-full" onMouseLeave={() => setIsOpen(false)}>
                <ProductsMenu 
                    isOpen={isOpen}
                    setIsOpen={setIsOpen}
                />
            </div>
        </nav>
        </>
    )
}

export default Navbar;